import axios from "axios";

export async function fetchChallengesDashboard() {
  return await axios
    .get("/admin/challenges/dashboard")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function storeChallengesAndTasks(data) {
  return await axios
    .post("/admin/challenges/store", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function storeLaunchProcessChallenge(data) {
  return await axios
    .post("/launch-process/challenges/store", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchAdminChallengesAndTasks() {
  return await axios
    .get("/admin/challenges")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchUserChallenges() {
  return await axios
    .get("/user/challenges")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchAdminDailyTasks() {
  return await axios
    .get("/admin/challenges/daily-tasks")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchUserDailyTasks() {
  return await axios
    .get("/user/challenges/daily-tasks")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchUserChallengeDetail(data) {
  return await axios
    .get(`/user/challenges/detail?challenge_uuid=${data}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function storeChallengesReminder(data) {
  return await axios
    .post("/admin/challenges/reminders/store", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function getChallengesReminder() {
  return await axios
    .get("/admin/challenges/reminders")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchAdminLeaderboard({ per_page, page, search }) {
  try {
    const response = await axios.get(
      `/admin/challenges/leaderboard?per_page=${per_page}&page=${page}&search=${search}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
}

export async function fetchAllRoles() {
  return await axios
    .get("/admin-courses/roles")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchChallengesSigns() {
  return await axios
    .get("/admin/challenges/sign")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchAdminUserResponse(taskUuid) {
  return await axios
    .get(`/admin/challenges/response?task_uuid=${taskUuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchUserChallengesResponse(userUuid) {
  return await axios
    .get(`/admin/challenges/challenge-response/${userUuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function deleteChallenge(uuid) {
  return await axios
    .delete(`/admin/challenges/${uuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function updateChallenge(uuid, formData) {
  formData.append("_method", "PUT");
  return await axios
    .post(`/admin/challenges/${uuid}`, formData)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchChallengeGroupDetails(uuid) {
  return await axios
    .get(`/admin/challenges/${uuid}/group-details`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function deleteChallengeReminder(uuid) {
  return await axios
    .delete(`/admin/challenges/reminders/delete/${uuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

// ==== User API's ===

export async function fetchUserChallengesDashboard() {
  return await axios
    .get("/user/challenges/dashboard")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchChallengesAndTasks() {
  return await axios
    .get("/user/challenges")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function updateTaskResponse(data) {
  return await axios
    .post("/user/challenges/complete-task", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchUserLeaderboard({ per_page, page, search, group_id = '' }) {
  try {
    const response = await axios.get(
      `/user/challenges/leaderboard?per_page=${per_page}&page=${page}&search=${search}&group_id=${group_id}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
}

export async function fetchActiveCampaigns() {
  try {
    const response = await axios.get("/user/challenges/active-campaigns");
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
}

export async function fetchUserTaskResponse(taskUuid) {
  return await axios
    .get(`/user/challenges/detail?challenge_uuid=${taskUuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function uploadTaskMedia(data) {
  return await axios
    .post("/user/challenges/task/media", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

// ==== Launch Process API's ===

export async function fetchLaunchProcessChallenges() {
  return await axios
    .get("/launch-process/challenges")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchLaunchProcessChallenge(uuid) {
  return await axios
    .get(`/launch-process/challenges/${uuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function updateLaunchProcessChallenge(uuid, data) {
  return await axios
    .post(`/launch-process/challenges/${uuid}/update`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function deleteLaunchProcessChallenge(uuid) {
  return await axios
    .delete(`/launch-process/challenges/${uuid}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchTraineeLaunchProcessChallenges() {
  return await axios
    .get("/launch-process/challenges/trainee")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function updateLaunchProcessTaskResponse(data) {
  return await axios
    .post("/launch-process/challenges/task/response", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchChallengeResponses(challengeUuid, search = '', page = 1, perPage = 10) {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  if (page) params.append('page', page);
  if (perPage) params.append('per_page', perPage);
  
  const queryString = params.toString();
  const url = `/launch-process/challenges/${challengeUuid}/responses${queryString ? '?' + queryString : ''}`;
  
  return await axios
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}

export async function fetchLaunchProcessLeaderboard(search = '') {
  const params = new URLSearchParams();
  if (search) params.append('search', search);
  
  const queryString = params.toString();
  const url = `/launch-process/leaderboard${queryString ? '?' + queryString : ''}`;
  
  return await axios
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error.response.data;
    });
}
